module.exports = __webpack_public_path__ + "static/media/fly0067.f5f4a125.webp";